import type { SVGProps } from "react";
const SenecPictogramAutostromTariff = (props: Pick<SVGProps<SVGSVGElement>, "color">) => (
    <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M34.745 6H42V8H35.255L25 13.5936V22C25 22.5523 24.5523 23 24 23C23.4477 23 23 22.5523 23 22V17H18.5803L14.5803 24H12.895L12.1173 31H23V27C23 26.4477 23.4477 26 24 26C24.5523 26 25 26.4477 25 27V36H34V29.9C31.7178 29.4367 30 27.419 30 25V23H32V21H34V25H32C32 26.6569 33.3431 28 35 28C36.6569 28 38 26.6569 38 25H36V21H38V23H40V25C40 27.419 38.2822 29.4367 36 29.9V36H42V38H36V39C36 40.6569 34.6569 42 33 42H9C7.34315 42 6 40.6569 6 39V28C6 26.3431 7.34315 25 9 25H10.7716L10.9073 23.7791C11.0198 22.7663 11.8759 22 12.895 22H13.4197L17.4197 15H23V12.4064L34.745 6ZM10.5494 27H9C8.44772 27 8 27.4477 8 28V39C8 39.5523 8.44772 40 9 40H33C33.5523 40 34 39.5523 34 39V38H23V33H19V38H12V32.9966C10.8651 32.9314 10.0022 31.9247 10.1295 30.7791L10.5494 27ZM14 33V36H17V33H14Z"
            fill="currentColor"
        />
        <path
            d="M15 27C15 25.8954 15.8954 25 17 25C18.1046 25 19 25.8954 19 27C19 28.1046 18.1046 29 17 29C15.8954 29 15 28.1046 15 27Z"
            fill="currentColor"
        />
    </svg>
);
export default SenecPictogramAutostromTariff;
